import React, { useEffect, useState } from 'react';

const introImage = (file) => encodeURI(`/astronomy-outreach/Intro/${file}`);

const images = [
  '1728207128741.jpg',
  '489007463_1073434464810726_1638183243399149778_n.jpg',
  '492622084_1232748342193990_481058589430418995_n.jpg',
  '498199856_1288073373328153_6696705067001669278_n.jpg',
  'DSC_5396.JPG',
  'DSC_6896.JPG',
  'WhatsApp Image 2025-05-26 at 12.20.08.jpg',
  'WhatsApp Image 2025-05-26 at 12.20.39.jpg',
  'WhatsApp Image 2025-07-02 at 11.40.46.jpg',
  'WhatsApp Image 2025-07-15 at 09.31.16.jpg',
  'WhatsApp Image 2025-07-15 at 11.02.34.jpg',
];

const AstronomyIntroduction = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setActiveIndex((current) => (current + 1) % images.length),
      3000,
    );
    return () => window.clearInterval(timer);
  }, []);

  const move = (direction) => {
    setActiveIndex((current) => (current + direction + images.length) % images.length);
  };

  return (
    <section className="astronomy-introduction-section" aria-labelledby="astronomy-introduction-title">
      <div className="astronomy-introduction-inner">
        <div className="astronomy-introduction-copy">
          <p className="section-eyebrow">CONNECTING PEOPLE WITH THE COSMOS</p>
          <h1 id="astronomy-introduction-title">Introduction</h1>
          <div className="astronomy-title-line" aria-hidden="true" />
          <p>
            The Astronomy Outreach Program of the Space Education and Research Lab (SERL) at the
            National Center of GIS and Space Applications (NCGSA) is dedicated to connecting people
            with the cosmos. We bring wonders of the cosmos closer to schools, communities, and the
            general public through astronomy education and stargazing sessions. Our outreach efforts
            aim to spark curiosity, encourage scientific thinking, and inspire the next generation of
            astronomers, scientists, and space enthusiasts across Pakistan.
          </p>
          <p>
            These efforts are led by the <strong>National Astronomy Education Coordinator (NAEC) for
            Pakistan</strong>, appointed by the <strong>Office of Astronomy for Education (OAE)</strong>
            {' '}under the <strong>International Astronomical Union (IAU)</strong>. This global affiliation
            ensures our programs reflect international standards and contribute to global astronomy
            education efforts.
          </p>
        </div>

        <div className="astronomy-introduction-carousel" aria-label="Astronomy Outreach image gallery">
          <figure>
            <img src={introImage(images[activeIndex])} alt={`Astronomy Outreach activity ${activeIndex + 1}`} />
          </figure>
          <button type="button" className="astronomy-carousel-arrow previous" onClick={() => move(-1)} aria-label="Previous image">‹</button>
          <button type="button" className="astronomy-carousel-arrow forward" onClick={() => move(1)} aria-label="Next image">›</button>
          <div className="astronomy-carousel-dots" aria-label="Choose image">
            {images.map((image, index) => (
              <button
                type="button"
                className={index === activeIndex ? 'active' : ''}
                onClick={() => setActiveIndex(index)}
                aria-label={`Show image ${index + 1}`}
                aria-current={index === activeIndex ? 'true' : undefined}
                key={image}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AstronomyIntroduction;
